<template>
	<div class="swipe-row">
		<div class="swipe-row-content"><slot></slot></div>
		<div class="swipe-row-actions"><slot name="actions"></slot></div>
	</div>
</template>

<script>
export default {
	name: "SwipeRow",
};
</script>

<style>
.swipe-row {
	width: 100%;
	overflow-x: auto;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-items: stretch;
	scroll-snap-type: x mandatory;
}
.swipe-row::-webkit-scrollbar {
	display: none;
}
.swipe-row-content {
	min-width: 100%;
	width: 100%;
	background-color: white;
	flex: 0 0;
	scroll-snap-align: end;
	position: relative;
}
.swipe-row-actions {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-items: stretch;
	flex: 0 0;
	scroll-snap-align: end;
}
</style>
